var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _path5, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _path6, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _path7, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _path8, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _path9, _rect122, _rect123, _rect124, _rect125, _path10, _path11, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _path12, _path13, _path14, _rect154, _rect155, _rect156, _path15, _rect157, _rect158, _path16, _path17, _path18, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _path19, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainLogoforMpd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1400,
    height: 400,
    viewBox: "0 0 1400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M838.172 217.486C831.045 202.156 816.354 194.815 799.561 189.129C799.609 188.484 799.643 187.837 799.662 187.19C800.527 173.539 792.971 160.458 779.996 153.821C772.504 149.991 762.351 148.219 754.296 147.937C752.777 145.764 751.343 143.483 749.722 141.391C739.471 128.166 722.608 120.399 704.804 121.334C683.335 122.461 664.816 135.923 658.195 155.212C646.748 148.234 631.999 147.557 619.748 153.821C605.737 160.985 598.016 175.685 600.46 190.535C576.706 193.664 558.581 212.15 557.132 234.727C555.367 262.151 576.363 283.527 605.359 283.527C613.773 283.551 745.585 283.569 753.229 283.593V294.282C738.642 294.282 619.85 293.829 605.327 293.787C589.109 293.739 573.664 288.071 562.36 276.983C550.622 265.467 545.253 249.943 546.27 234.107C547.831 209.836 565.24 189.45 589.217 182.427C590.19 166.834 599.605 152.452 614.561 144.802C626.37 138.765 640.219 137.707 652.705 141.502C663.055 123.936 682.365 112.237 704.2 111.089C725.3 109.983 746.044 119.26 758.505 135.339C759.204 136.238 759.862 137.155 760.504 138.084C769.001 138.954 777.968 141.112 785.183 144.802C799.831 152.293 809.386 166.621 810.498 182.103C826.713 188.428 840.658 197.267 848.137 213.367C851.087 219.719 852.816 226.526 853.245 233.447C854.202 248.869 849.704 263.563 838.414 274.993C815.718 297.966 782.659 294.282 752.567 294.282C752.567 294.282 752.567 286.108 752.567 283.593L780.066 284.036C813.928 284.135 844.672 270.904 842.384 234.047C842.031 228.354 840.61 222.743 838.172 217.486Z",
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M707.766 236.011L709.542 234.274V237.748H705.99L707.766 236.011Z",
    fill: "#111111"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M716.648 234.848H720.2V237.742H716.648L716.648 234.848Z",
    fill: "#111111"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M722 234.848L723.776 236.295L725.552 237.742H722L722 234.848Z",
    fill: "#111111"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 705.99,
    y: 249.314,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 705.99,
    y: 254.239,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 705.99,
    y: 239.189,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 705.99,
    y: 259.16,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 705.99,
    y: 244.108,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 705.99,
    y: 264.076,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 705.99,
    y: 268.992,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 705.99,
    y: 273.918,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 705.99,
    y: 278.84,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 716.701,
    y: 249.31,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 716.701,
    y: 254.239,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 716.701,
    y: 239.185,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 716.701,
    y: 259.155,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 716.701,
    y: 244.103,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 716.701,
    y: 264.08,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 716.701,
    y: 268.994,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 716.701,
    y: 273.919,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 716.701,
    y: 278.835,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 721.949,
    y: 249.314,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 721.949,
    y: 254.241,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 721.949,
    y: 239.189,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 721.949,
    y: 259.16,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 721.949,
    y: 244.106,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 721.949,
    y: 264.086,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 721.949,
    y: 268.993,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 721.949,
    y: 273.923,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 721.949,
    y: 278.84,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 727.311,
    y: 249.313,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 732.613,
    y: 249.313,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 727.311,
    y: 254.238,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 732.613,
    y: 254.242,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 727.311,
    y: 239.188,
    width: 2.37521,
    height: 3.47317,
    fill: "#111111"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 727.311,
    y: 259.158,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 732.613,
    y: 259.16,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 727.311,
    y: 244.104,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 727.311,
    y: 264.077,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 732.613,
    y: 264.083,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 727.311,
    y: 268.994,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 732.613,
    y: 268.998,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 727.311,
    y: 273.923,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 732.613,
    y: 273.922,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 727.311,
    y: 278.838,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 732.613,
    y: 278.841,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 711.33,
    y: 249.307,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 711.33,
    y: 254.239,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 711.33,
    y: 239.177,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M711.33 235.995H714.882V237.732H711.33V235.995Z",
    fill: "#111111"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 711.33,
    y: 259.147,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 711.33,
    y: 244.095,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 711.33,
    y: 264.07,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 711.33,
    y: 268.987,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 711.33,
    y: 273.911,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 711.33,
    y: 278.828,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 745.035,
    y: 250.211,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 745.035,
    y: 255.025,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M745.943 240.277H748.546V243.682H745.943L745.943 240.277Z",
    fill: "#111111"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 745.035,
    y: 259.854,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 745.035,
    y: 245.1,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 745.035,
    y: 264.683,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 745.035,
    y: 269.493,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 745.035,
    y: 274.336,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 745.035,
    y: 279.152,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 755.457,
    y: 250.226,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 755.457,
    y: 255.045,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 755.457,
    y: 240.289,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 755.457,
    y: 235.465,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 755.457,
    y: 230.835,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M757.146 227.854L758.939 226.203V229.608H755.457L757.146 227.854Z",
    fill: "#111111"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 755.457,
    y: 259.867,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 755.457,
    y: 245.11,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 755.457,
    y: 264.69,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 755.457,
    y: 269.511,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 755.457,
    y: 274.332,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 755.457,
    y: 279.163,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 760.666,
    y: 250.208,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 760.666,
    y: 255.033,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 760.666,
    y: 240.271,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 760.666,
    y: 235.453,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 760.666,
    y: 230.819,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 760.666,
    y: 226.185,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 760.666,
    y: 222.713,
    width: 3.48206,
    height: 2.31545,
    fill: "#111111"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 765.891,
    y: 240.271,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 765.891,
    y: 235.452,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 765.891,
    y: 230.817,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 765.891,
    y: 226.182,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 765.891,
    y: 222.713,
    width: 3.48206,
    height: 2.31545,
    fill: "#111111"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 771.045,
    y: 240.271,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 771.045,
    y: 235.452,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 771.045,
    y: 230.817,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 771.045,
    y: 226.182,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 771.037,
    y: 222.713,
    width: 3.48206,
    height: 2.31545,
    fill: "#111111"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 760.666,
    y: 259.853,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 760.666,
    y: 245.096,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 760.666,
    y: 264.684,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 760.666,
    y: 269.505,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 760.666,
    y: 274.326,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 760.666,
    y: 279.151,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 765.893,
    y: 250.21,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 771.117,
    y: 250.207,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 765.893,
    y: 255.046,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 771.117,
    y: 255.043,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 765.893,
    y: 259.861,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 771.117,
    y: 259.861,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 765.893,
    y: 245.109,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 771.053,
    y: 245.109,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 765.893,
    y: 264.688,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 771.117,
    y: 264.692,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 765.893,
    y: 269.514,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 771.117,
    y: 269.51,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 765.893,
    y: 274.329,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 771.117,
    y: 274.331,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 765.893,
    y: 279.161,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 771.117,
    y: 279.164,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 750.234,
    y: 250.217,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 750.234,
    y: 255.044,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 750.234,
    y: 240.286,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 750.234,
    y: 235.457,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M752.01 232.563L753.716 230.826V234.231H750.234L752.01 232.563Z",
    fill: "#111111"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 750.234,
    y: 259.865,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 750.234,
    y: 245.105,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 750.234,
    y: 264.686,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 750.234,
    y: 269.516,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 750.234,
    y: 274.329,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 750.234,
    y: 279.153,
    width: 3.48206,
    height: 3.40507,
    fill: "#111111"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 666.334,
    y: 249.319,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M671.637 249.89L673.413 251.338L675.188 252.785H671.637V249.89Z",
    fill: "#111111"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 666.334,
    y: 254.247,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 671.637,
    y: 254.251,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 666.334,
    y: 259.164,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 671.637,
    y: 259.164,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M676.998 259.164L678.774 260.901L680.55 262.637H676.998V259.164Z",
    fill: "#111111"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M691.186 259.164L689.41 260.901L687.634 262.637H691.186V259.164Z",
    fill: "#111111"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 666.334,
    y: 264.071,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 671.637,
    y: 264.089,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 676.998,
    y: 264.089,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    width: 3.5517,
    height: 3.47317,
    transform: "matrix(-1 0 0 1 691.186 264.086)",
    fill: "#111111"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 682.309,
    y: 264.085,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 666.334,
    y: 269,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 671.637,
    y: 268.999,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 676.998,
    y: 268.999,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    width: 3.5517,
    height: 3.47317,
    transform: "matrix(-1 0 0 1 691.186 268.999)",
    fill: "#111111"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 682.309,
    y: 268.999,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 666.334,
    y: 273.922,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 671.637,
    y: 273.926,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 676.998,
    y: 273.926,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    width: 3.5517,
    height: 3.47317,
    transform: "matrix(-1 0 0 1 691.186 273.926)",
    fill: "#111111"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 682.309,
    y: 273.922,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 666.334,
    y: 278.848,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 671.637,
    y: 278.846,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    width: 3.5517,
    height: 3.47317,
    transform: "matrix(-1 0 0 1 696.525 254.253)",
    fill: "#111111"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    width: 3.5517,
    height: 3.47317,
    transform: "matrix(-1 0 0 1 696.525 249.319)",
    fill: "#111111"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    width: 3.5517,
    height: 3.47317,
    transform: "matrix(-1 0 0 1 696.525 259.164)",
    fill: "#111111"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    width: 3.5517,
    height: 3.47317,
    transform: "matrix(-1 0 0 1 696.525 264.089)",
    fill: "#111111"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    width: 3.5517,
    height: 3.47317,
    transform: "matrix(-1 0 0 1 696.525 268.999)",
    fill: "#111111"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    width: 3.5517,
    height: 3.47317,
    transform: "matrix(-1 0 0 1 696.525 273.926)",
    fill: "#111111"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    width: 3.5517,
    height: 3.47317,
    transform: "matrix(-1 0 0 1 696.525 278.846)",
    fill: "#111111"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 676.998,
    y: 278.846,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    width: 3.5517,
    height: 3.47317,
    transform: "matrix(-1 0 0 1 691.186 278.846)",
    fill: "#111111"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 682.309,
    y: 278.846,
    width: 3.5517,
    height: 3.47317,
    fill: "#111111"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 627.281,
    y: 249.318,
    width: 3.48206,
    height: 3.47317,
    fill: "#111111"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M632.504 249.892L634.245 251.339L635.986 252.787H632.504V249.892Z",
    fill: "#111111"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M639.726 265.826L641.223 264.089V267.562H638.246L639.726 265.826Z",
    fill: "#111111"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M639.703 259.165H641.485V262.638H639.703V259.165Z",
    fill: "#111111"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    width: 3.48206,
    height: 3.47317,
    transform: "matrix(-1 0 0 1 651.66 264.083)",
    fill: "#111111"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    width: 3.48206,
    height: 3.47317,
    transform: "matrix(-1 0 0 1 651.66 259.166)",
    fill: "#111111"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    width: 3.48206,
    height: 3.47317,
    transform: "matrix(-1 0 0 1 651.66 254.525)",
    fill: "#111111"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M651.66 249.816L648.178 249.816V252.793H651.66V249.816Z",
    fill: "#111111"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 642.934,
    y: 264.089,
    width: 3.48206,
    height: 3.47317,
    fill: "#111111"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    x: 642.934,
    y: 259.165,
    width: 3.48206,
    height: 3.47317,
    fill: "#111111"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M642.934 254.525L646.416 254.525V257.998H642.934L642.934 254.525Z",
    fill: "#111111"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M632.504 271.312L635.986 269.865V272.469H632.504V271.312Z",
    fill: "#111111"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M630.783 271.321L627.301 269.874V272.479H630.783V271.321Z",
    fill: "#111111"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 637.717,
    y: 268.999,
    width: 3.48206,
    height: 3.47317,
    fill: "#111111"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    width: 3.48206,
    height: 3.47317,
    transform: "matrix(-1 0 0 1 651.66 268.999)",
    fill: "#111111"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    x: 642.934,
    y: 268.999,
    width: 3.48206,
    height: 3.47317,
    fill: "#111111"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    x: 627.281,
    y: 273.922,
    width: 3.48206,
    height: 3.47317,
    fill: "#111111"
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    x: 632.504,
    y: 273.92,
    width: 3.48206,
    height: 3.47317,
    fill: "#111111"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    x: 637.717,
    y: 273.922,
    width: 3.48206,
    height: 3.47317,
    fill: "#111111"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    width: 3.48206,
    height: 3.47317,
    transform: "matrix(-1 0 0 1 651.66 273.92)",
    fill: "#111111"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    x: 642.934,
    y: 273.928,
    width: 3.48206,
    height: 3.47317,
    fill: "#111111"
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    x: 627.281,
    y: 278.848,
    width: 3.48206,
    height: 3.47317,
    fill: "#111111"
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    x: 632.504,
    y: 278.846,
    width: 3.48206,
    height: 3.47317,
    fill: "#111111"
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    width: 3.48206,
    height: 3.47317,
    transform: "matrix(-1 0 0 1 656.887 254.248)",
    fill: "#111111"
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    width: 3.48206,
    height: 3.47317,
    transform: "matrix(-1 0 0 1 656.887 249.318)",
    fill: "#111111"
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    width: 3.48206,
    height: 3.47317,
    transform: "matrix(-1 0 0 1 656.887 259.165)",
    fill: "#111111"
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    width: 3.48206,
    height: 3.47317,
    transform: "matrix(-1 0 0 1 656.887 264.083)",
    fill: "#111111"
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    width: 3.48206,
    height: 3.47317,
    transform: "matrix(-1 0 0 1 656.887 268.999)",
    fill: "#111111"
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    width: 3.48206,
    height: 3.47317,
    transform: "matrix(-1 0 0 1 656.887 273.92)",
    fill: "#111111"
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    width: 3.48206,
    height: 3.47317,
    transform: "matrix(-1 0 0 1 656.887 278.848)",
    fill: "#111111"
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    x: 637.717,
    y: 278.846,
    width: 3.48206,
    height: 3.47317,
    fill: "#111111"
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    width: 3.48206,
    height: 3.47317,
    transform: "matrix(-1 0 0 1 651.66 278.848)",
    fill: "#111111"
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    x: 642.934,
    y: 278.846,
    width: 3.48206,
    height: 3.47317,
    fill: "#111111"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M631.385 255.383C632.956 255.383 634.415 255.846 635.63 256.639C640.462 252.113 645.295 247.589 650.129 243.065C649.427 241.934 649.025 240.609 649.025 239.191C649.025 235.05 652.457 231.694 656.69 231.694C660.926 231.694 664.358 235.05 664.358 239.191C664.358 239.955 664.239 240.693 664.023 241.387C668.752 244.024 673.483 246.66 678.214 249.295C679.616 247.79 681.633 246.847 683.879 246.847C685.476 246.847 686.958 247.324 688.186 248.143C694.341 242.493 700.496 236.843 706.651 231.193C705.974 230.076 705.586 228.774 705.586 227.383C705.586 223.242 709.018 219.885 713.251 219.885C717.487 219.885 720.918 223.242 720.918 227.383C720.916 228.073 720.825 228.737 720.643 229.373C724.526 231.536 728.409 233.699 732.29 235.863C733.692 234.359 735.709 233.415 737.955 233.415C739.552 233.415 741.034 233.893 742.262 234.709C748.417 229.061 754.572 223.412 760.727 217.762C760.049 216.645 759.662 215.343 759.662 213.951C759.662 209.81 763.093 206.454 767.327 206.454C771.563 206.454 774.994 209.81 774.994 213.951C774.994 218.092 771.563 221.448 767.327 221.448C765.732 221.448 764.25 220.971 763.022 220.155C756.867 225.805 750.712 231.454 744.557 237.102C745.232 238.219 745.622 239.521 745.622 240.913C745.622 245.053 742.188 248.41 737.955 248.41C733.721 248.41 730.29 245.053 730.29 240.913C730.29 240.149 730.408 239.408 730.624 238.713C726.771 236.566 722.917 234.419 719.064 232.27C717.658 233.87 715.576 234.88 713.251 234.88C711.656 234.88 710.174 234.402 708.947 233.586C702.791 239.236 696.636 244.886 690.481 250.536C691.159 251.65 691.546 252.952 691.546 254.344C691.546 258.485 688.112 261.844 683.879 261.844C679.646 261.844 676.214 258.485 676.214 254.344C676.214 253.58 676.332 252.842 676.548 252.145C671.819 249.51 667.09 246.874 662.361 244.237C660.959 245.745 658.938 246.688 656.69 246.688C655.122 246.688 653.664 246.228 652.448 245.435L637.95 259.008C638.648 260.14 639.05 261.465 639.05 262.883C639.05 267.023 635.619 270.38 631.385 270.38C627.152 270.38 623.721 267.023 623.721 262.883C623.721 258.742 627.152 255.383 631.385 255.383ZM737.955 236.355C735.381 236.355 733.295 238.395 733.295 240.913C733.295 243.43 735.381 245.47 737.955 245.47C740.528 245.47 742.614 243.43 742.614 240.913C742.614 238.395 740.528 236.355 737.955 236.355ZM767.327 209.394C764.756 209.394 762.667 211.434 762.667 213.951C762.667 216.468 764.756 218.508 767.327 218.508C769.9 218.508 771.989 216.468 771.989 213.951C771.989 211.434 769.9 209.394 767.327 209.394ZM656.69 234.634C654.119 234.634 652.031 236.674 652.031 239.191C652.031 241.708 654.119 243.748 656.69 243.748C659.263 243.748 661.349 241.708 661.349 239.191C661.349 236.674 659.263 234.634 656.69 234.634ZM683.879 249.787C681.308 249.787 679.22 251.827 679.22 254.344C679.22 256.861 681.308 258.901 683.879 258.901C686.452 258.901 688.538 256.861 688.538 254.344C688.538 251.827 686.452 249.787 683.879 249.787ZM713.251 222.825C710.68 222.825 708.592 224.865 708.592 227.383C708.592 229.9 710.68 231.94 713.251 231.94C715.824 231.94 717.913 229.9 717.913 227.383C717.913 224.865 715.824 222.825 713.251 222.825ZM631.385 258.326C628.812 258.326 626.726 260.365 626.726 262.883C626.726 265.4 628.812 267.44 631.385 267.44C633.959 267.44 636.045 265.4 636.045 262.883C636.045 260.365 633.959 258.326 631.385 258.326Z",
    fill: "#111111"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M656.764 230.093V195.434C656.764 193.007 654.768 191.019 652.328 191.019H631.602C629.161 191.019 627.166 193.007 627.166 195.434V254.768C628.417 254.129 629.839 253.767 631.343 253.767C632.707 253.767 634.045 254.068 635.263 254.644L647.785 242.72C647.314 241.606 647.069 240.405 647.069 239.184C647.069 234.155 651.167 230.075 656.223 230.075C656.405 230.075 656.585 230.081 656.764 230.093Z",
    fill: "#111111"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M666.379 240.848L677.765 247.304C679.393 245.973 681.438 245.235 683.576 245.235C684.971 245.235 686.335 245.547 687.577 246.149L695.976 238.308V165.982C695.976 163.554 693.978 161.567 691.538 161.567H670.817C668.377 161.567 666.379 163.554 666.379 165.982V240.848Z",
    fill: "#111111"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M706.256 144.924V222.139C707.911 219.801 710.648 218.274 713.74 218.274C718.798 218.274 722.896 222.353 722.896 227.382C722.896 227.774 722.871 228.163 722.823 228.548L732.218 233.875C733.282 233.004 734.524 232.388 735.853 232.064V144.924C735.853 142.496 733.858 140.508 731.418 140.508H710.691C708.251 140.508 706.256 142.496 706.256 144.924Z",
    fill: "#111111"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M744.924 230.084L758.511 217.399C758.063 216.305 757.831 215.136 757.831 213.944C757.831 208.915 761.928 204.835 766.983 204.835C770.109 204.835 772.869 206.395 774.521 208.773V195.434C774.521 193.007 772.523 191.019 770.083 191.019H749.362C746.922 191.019 744.924 193.007 744.924 195.434V230.084Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogoforMpd);
export default __webpack_public_path__ + "static/media/MainLogoforMPD.417920d5615a1a1e4302908a6f0f4fbe.svg";
export { ForwardRef as ReactComponent };